export default {
    classFix:'burgeon-', //class前缀
    componentsFix:'', //components前缀
    prefixCls:'burgeon-' //前缀
};


// WEBPACK FOOTER //
// ./src/assets/config.js